import { jsx as _jsx } from "react/jsx-runtime";
import NotFoundPage from "pages/notFoundPage/NotFoundPage";
import { useLocaleStore } from "store/localeStore";
import { isSuperAdmin } from "./adminRole";
// Разделы, доступные только SUPER_ADMIN (комиссии, история выводов). Внешний
// AdminGuard уже проверил/обновил токен, поэтому проверку делаем синхронно.
export var SuperAdminRoute = function (_a) {
    var children = _a.children;
    var locale = useLocaleStore(function (state) { return state.locale; });
    var setLocale = useLocaleStore(function (state) { return state.setLocale; });
    if (!isSuperAdmin()) {
        return _jsx(NotFoundPage, { currentLocale: locale, onLocaleChange: setLocale });
    }
    return children;
};
